// extracted by mini-css-extract-plugin
export default {"mainDiv":"CleanerDetails_mainDiv__laBQR","heading":"CleanerDetails_heading__HQIJp","used_search_input":"CleanerDetails_used_search_input__pnsWa"};